import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const TABLET_MIN = 768;
const TABLET_MAX = 1028;

function getIsCondensedViewport() {
    if (typeof window === 'undefined') return false;
    return window.innerWidth >= TABLET_MIN && window.innerWidth <= TABLET_MAX;
}

export default function useVerticalLayoutController({ children }) {
    const location = useLocation();
    const [isCondensed, setIsCondensed] = useState(getIsCondensedViewport);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const updateDimensions = () => {
            setIsCondensed(getIsCondensedViewport());
            if (window.innerWidth > 991.98) {
                setIsMobileMenuOpen(false);
            }
        };

        window.addEventListener('resize', updateDimensions);
        return () => window.removeEventListener('resize', updateDimensions);
    }, []);

    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location.pathname]);

    const openLeftMenu = useCallback(() => {
        setIsMobileMenuOpen((prev) => !prev);
    }, []);

    const closeMobileMenu = useCallback(() => {
        setIsMobileMenuOpen(false);
    }, []);

    return {
        children,
        isCondensed,
        isMobileMenuOpen,
        openLeftMenu,
        closeMobileMenu,
    };
}
